export default "__VITE_ASSET__b73cd197__"